import { LmmMaterieelTimed, LmmVerrijktV2 } from '../types/LmmVoorraad';
import { getLmmMaterieelCategoryFull } from '../utils/lmmMaterieelCategory';

export const defaultLmmVoorraadVerrijkt = (defaultValues: Partial<LmmVerrijktV2> = {}): LmmVerrijktV2 =>
  structuredClone({
    materieel: '',
    matCategory: defaultValues?.materieel ? getLmmMaterieelCategoryFull(defaultValues.materieel) : 'other',
    nvt: true,
    brutoPark: 0,
    benodigd: {
      dienst: 0,
      gdst: 0,
      ebksb: 0,
    },
    nietInzetbaar: {
      aantalEenheden: 0,
      defecten: {
        aantal: 0,
        ids: [],
      },
    },
    verwachtGereed: {
      aantalEenheden: 0,
      defecten: {
        aantal: 0,
        ids: [],
      },
    },
    overOfTekort: 0,
    ...defaultValues,
  });

export const defaultLmmMaterieelTimed = ({ materieel }: { materieel: string }): LmmMaterieelTimed =>
  structuredClone({
    NU: defaultLmmVoorraadVerrijkt({ materieel }),
    ['08:00']: defaultLmmVoorraadVerrijkt({ materieel }),
    ['17:00']: defaultLmmVoorraadVerrijkt({ materieel }),
  });
